"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValue = void 0;
const data_types_1 = require("@yanzi/data-types");
const temperature_1 = require("@yanzi/temperature");
function formatValue(value, dataType, options = {}) {
    const { decimals = 0, emptyRepresentation = '', preferredTemperatureUnit, showValue = true, showUnit = true, } = options;
    if (typeof dataType === 'object' && dataType !== null) {
        if (data_types_1.isVariableNameDataType(dataType)) {
            return formatValue(value, dataType.variableName, options);
        }
        throw new Error('Unknown type ' + JSON.stringify(dataType));
    }
    switch (dataType) {
        case 'temperature':
        case 'temperatureC':
        case 'temperatureF':
        case 'temperatureK': {
            const inPreferredUnit = temperature_1.convertTemp(value, temperature_1.variableNameToTemperatureUnit(dataType === 'temperature' ? 'temperatureK' : dataType), preferredTemperatureUnit);
            const unit = showUnit
                ? temperature_1.unitStringForTemperatureUnit(preferredTemperatureUnit ||
                    temperature_1.variableNameToTemperatureUnit(dataType === 'temperature' ? 'temperatureK' : dataType))
                : '';
            return `${showValue
                ? Number(inPreferredUnit).toLocaleString(undefined, {
                    maximumFractionDigits: decimals === undefined ? 0 : decimals,
                })
                : ''}${unit}`;
        }
        case 'illuminance':
            return value || value === 0
                ? `${showValue
                    ? Number(value / 1000).toLocaleString(undefined, {
                        maximumFractionDigits: decimals,
                    })
                    : ''}${showUnit ? 'lux' : ''}`
                : emptyRepresentation;
        case 'pressure':
            return value || value === 0
                ? `${showValue
                    ? Number(value / 100).toLocaleString(undefined, {
                        maximumFractionDigits: decimals,
                    })
                    : ''}${showUnit ? 'hPa' : ''}`
                : emptyRepresentation;
        case 'soundPressureLevel':
            return value || value === 0
                ? `${showValue
                    ? Number(value / 100).toLocaleString(undefined, {
                        maximumFractionDigits: decimals,
                    })
                    : ''}${showUnit ? 'dBA' : ''}`
                : emptyRepresentation;
        case 'carbonDioxide':
            return value || value === 0
                ? `${showValue
                    ? Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals })
                    : ''}${showUnit ? 'ppm' : ''}`
                : emptyRepresentation;
        case 'relativeHumidity':
            return value || value === 0
                ? `${showValue
                    ? Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals })
                    : ''}${showUnit ? '%RH' : ''}`
                : emptyRepresentation;
        case 'volatileOrganicCompound':
            return value || value === 0
                ? `${showValue
                    ? Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals })
                    : ''}${showUnit ? 'ppb' : ''}`
                : emptyRepresentation;
        case 'healthScore':
            return value || value === 0
                ? `${showValue
                    ? Math.max(0, Math.min(100, Number(value))).toLocaleString(undefined, {
                        maximumFractionDigits: decimals,
                    })
                    : ''}`
                : emptyRepresentation;
        case 'assetUtilization':
        case 'utilization':
            return value || value === 0
                ? `${showValue
                    ? Math.max(0, Math.min(100, Number(value * 100))).toLocaleString(undefined, {
                        maximumFractionDigits: decimals,
                    })
                    : ''}${showUnit ? '%' : ''}`
                : emptyRepresentation;
        case 'dollar':
            return value || value === 0
                ? `${showUnit ? '$ ' : ''}${showValue ? value.toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '-'}`
                : emptyRepresentation;
    }
}
exports.formatValue = formatValue;
//# sourceMappingURL=formatValue.js.map